import React from 'react';
import SabeeAppComponent from '../component/SabeeAppComponent';
const SabeeAppHtmlRenderer = (props) => {
    const { data } = props;
    return (React.createElement(SabeeAppComponent, { props: data }));
};
export default SabeeAppHtmlRenderer;
//# sourceMappingURL=SabeeAppHtmlRenderer.js.map